export default {
  el: '#reportsCharts',
  data: () => { 
    return {
      filtersChanged: false
    } 
  },
  mounted: () => {
    const changeEmptyData = function (data) {
      if (data.length == 1) {
        data.push(['Немає даних за вибраний період', 100, '#f2f2f2'])
      }
    }
    const chartLoader = document.createElement('script')
    chartLoader.setAttribute('src', 'https://www.gstatic.com/charts/loader.js')
    document.head.appendChild(chartLoader)
    chartLoader.onload = () => {
      const rangeSettings = {
        locale: {
          format: "DD.MM.YYYY",
          separator: " - ",
          applyLabel: "Прийняти",
          cancelLabel: "Відмінити",
          fromLabel: "Від",
          toLabel: "До",
          customRangeLabel: "Custom",
          weekLabel: "W",
          daysOfWeek: ["Нд", "Пн", "Вт", "Ср", "Чт", "Пт", "Сб"],
          monthNames: [
            "Січень",
            "Лютий",
            "Березень",
            "Квітень",
            "Травень",
            "Червень",
            "Липень",
            "Серпень",
            "Вересень",
            "Жовтень",
            "Листопад",
            "Грудень",
          ],
          firstDay: 1,
        },
      };
      $('#chartDateRange').daterangepicker(rangeSettings, function (begin, end) {
        document.getElementById('dateBegin').value = moment(begin).format('DD.MM.YYYY')
        document.getElementById('dateEnd').value = moment(end).format('DD.MM.YYYY')
        document.getElementById('submitBtn').classList.remove('hidden')
      })
      var drawChartUDC = function (selection) {
        let data = reportData['udc'][selection.row+1]
        if (typeof data == 'object') {
          data = Object.values(data)
        }
        if (data.length == 1) {
          data.push(['Дані відсутні', 1])
        }
        const chartData = google.visualization.arrayToDataTable(data)

        const options = {
          pieHole: 0.3, 
          sliceVisibilityThreshold: 0,
          chartArea: {
            left: 0,
            top: '3%',
            width: '100%',
            height: '94%'
          },
          legendTextStyle: {
            fontSize: 11.5
          },
          legendMaxLines: 2,
          tooltip: {
            isHtml: true
          }
        }
        const udcChart = new google.visualization.PieChart(document.getElementById('udcChart'))

        google.visualization.events.addListener(udcChart, 'ready', function () {
          let legend = document.getElementById('udcChart').querySelector('svg g:first-of-type');
          const items = legend.querySelectorAll('g[column-id]');

          const maxLines = 2;
          const linesNumber = (lines) => lines > maxLines ? maxLines : lines;
          const fontSize = 12;
          const spacing = 6;
          const offset = 11;

          let prevY = offset;

          for (let i = 0; i < items.length; i++) {
            const texts = items[i].querySelectorAll('text');
            const rects = items[i].querySelectorAll('rect');
            const circle = items[i].querySelector('circle');

            circle.setAttribute('cy', prevY - spacing / 3);

            const _lines = linesNumber(texts.length);
            for (let j = 0; j < _lines; j++) {
              const y = prevY + fontSize * j;
              texts[j].setAttribute('y', y);
            }
            for (let j = maxLines; j < texts.length; j++) {
              texts[j].parentElement.removeChild(texts[j]);
            }

            for (let j = 0; j < rects.length; j++) {
              rects[j].setAttribute('height', fontSize * (_lines - 1) + spacing * _lines);
              rects[j].setAttribute('y', prevY - offset);
            }

            const spacingSingleLine = _lines > 1 ? 0 : spacing;
            let update = fontSize * (_lines - 1) + spacing * (_lines + 1) + spacingSingleLine;
            prevY += update;
          }
        });

        function eventHandler(e){
            udcChart.setSelection([e]);
            selection = udcChart.getSelection();

            if (selection.length > 0) {
              const tooltip = document.querySelector('.google-visualization-tooltip');
              if (tooltip !== null) {
                tooltip.style.width = (tooltip.offsetWidth + 2) + 'px';
              }
            }
        }

        google.visualization.events.addListener(udcChart, 'onmouseover', eventHandler);

        udcChart.draw(chartData, options)
      }
      const randomColor = function () {
        let r = 50 + parseInt(Math.random() * 150)
        let g = 50 + parseInt(Math.random() * 150)
        let b = 50 + parseInt(Math.random() * 150)
        return `rgb(${r}, ${g}, ${b})` 
      }
      const colors = []
      for (const k in reportData.main) {
        if (k > 0)
          if (reportData.main[k][1] > 0) {
            colors.push(randomColor())
          } else {
            colors.push('#eeeeee')
          }
      }
      var drawChart = function() {
        const mainChartData = google.visualization.arrayToDataTable(reportData.main)
        const options = {
          pieHole: 0.3, 
          sliceVisibilityThreshold: 0,
          chartArea: {
            left: 0,
            top: '3%',
            width: '100%',
            height: '94%'
          },
          colors: colors,
          legendTextStyle: {
            fontSize: 11.5
          }
        }
        const mainChart = new google.visualization.PieChart(document.getElementById('mainChart'))
        google.visualization.events.addListener(mainChart, 'select', () => {
          const selection = mainChart.getSelection()
          drawChartUDC(selection[0])
        })
        mainChart.draw(mainChartData, options)
        drawChartUDC({row: 0})
      }
      google.charts.load('current', {packages: ['corechart']})
      google.charts.setOnLoadCallback(drawChart)
    }
  },
  methods: {
    reload() {
      this.filtersChanged = true
      document.getElementById('submitBtn').classList.remove('hidden')
    }
  }
}
